// extracted by mini-css-extract-plugin
export var buttons = "_ac-0";
export var buttonsActive = "_ac-h";
export var cancelConfirm = "_ac-1";
export var closeButton = "_ac-2";
export var column = "_ac-3";
export var container = "_ac-4";
export var detailHeader = "_ac-6";
export var detailTitle = "_ac-7";
export var detailsContent = "_ac-5";
export var header = "_ac-8";
export var headerWithClose = "_ac-9";
export var icon = "_ac-a";
export var infoIcon = "_ac-c";
export var informationContainer = "_ac-b";
export var sideDrawer = "_ac-d";
export var sideDrawerOpen = "_ac-e";
export var stickyFooter = "_ac-f";
export var typeOption = "_ac-g";